// eslint-disable-next-line object-curly-newline
import moment from 'moment'
import 'moment/locale/pt-br'
import {
  reactive, getCurrentInstance, watch, toRefs,
} from '@vue/composition-api'

export const isObject = obj => typeof obj === 'object' && obj !== null

export const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

const getRandomFromArray = array => array[Math.floor(Math.random() * array.length)]

// ? Light and Dark variant is not included
// prettier-ignore
export const getRandomBsVariant = () => getRandomFromArray(['primary', 'secondary', 'success', 'warning', 'danger', 'info'])

export const isDynamicRouteActive = route => {
  const vm = getCurrentInstance && getCurrentInstance()
  const routerInstance = vm && vm.proxy ? vm.proxy.$router : null
  if (!routerInstance) return false

  const { route: resolvedRoute } = routerInstance.resolve(route)
  return resolvedRoute.path === routerInstance.currentRoute.path
}

// Thanks: https://medium.com/better-programming/reactive-vue-routes-with-the-composition-api-18c1abd878d1
export const useRouter = () => {
  const vm = getCurrentInstance().proxy
  const state = reactive({
    route: vm.$route,
  })

  watch(
    () => vm.$route,
    r => {
      state.route = r
    },
  )

  return { ...toRefs(state), router: vm.$router }
}

export const generateCode = () => Date.now().toString(36) + Math.random().toString(36).substring(2)

export const formatDate = date => {
  const datePart = date.match(/\d+/g)
  const year = datePart[0].substring(0)
  const month = datePart[1]
  const day = datePart[2]

  return `${day}/${month}/${year}`
}

export const convertDateWithHour = date => {
  const data = moment(date).format('DD/MM/YYYY')
  const horario = date.split('T')[1].split(':')
  return `${data} ${horario[0]}:${horario[1]}`
}

export const aplicaMascara = inscricao => {
  if (inscricao) {
    if ((inscricao).replace(/[^0-9]/g, '').length === 11) {
      return (inscricao) ? (inscricao).replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : ''
    }
    return (inscricao) ? (inscricao).replace(/[^0-9]/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5') : ''
  }
  return null
}

export const isNumber = evt => {
  const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
  const keyPressed = evt.key

  if (!keysAllowed.includes(keyPressed)) {
    evt.preventDefault()
  }
}

export const abrirEmNovaGuia = (rota, valueId = 0, target = '_blank') => {
  const vm = getCurrentInstance && getCurrentInstance()
  let routerInstance = vm && vm.proxy ? vm.proxy.$router : null

  // Fallback to dynamic require if no current instance is available
  if (!routerInstance) {
    // eslint-disable-next-line global-require
    const maybeRouter = require('@/router')
    routerInstance = maybeRouter && maybeRouter.default ? maybeRouter.default : maybeRouter
  }

  let routeData = null
  if (valueId && valueId > 0) {
    routeData = routerInstance.resolve({ name: rota, params: { id: valueId }, query: { newAba: true } })
  } else {
    routeData = routerInstance.resolve({ name: rota })
  }
  window.open(routeData.href, target)
}

/**
 * This is just enhancement over Object.extend [Gives deep extend]
 * @param {target} a Object which contains values to be overridden
 * @param {source} b Object which contains values to override
 */
// export const objectExtend = (a, b) => {
//   // Don't touch 'null' or 'undefined' objects.
//   if (a == null || b == null) {
//     return a
//   }

//   Object.keys(b).forEach(key => {
//     if (Object.prototype.toString.call(b[key]) === '[object Object]') {
//       if (Object.prototype.toString.call(a[key]) !== '[object Object]') {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = b[key]
//       } else {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = objectExtend(a[key], b[key])
//       }
//     } else {
//       // eslint-disable-next-line no-param-reassign
//       a[key] = b[key]
//     }
//   })

//   return a
// }
